import moment, { Moment, isMoment } from 'moment';
import React from 'react';
// @ts-ignore
import DatePicker from '@cimpress/react-components/lib/DatePicker';
import { Location } from '../../locations/locationsModels';
import { DateString } from '../../common/commonModels';

interface Props {
  selectedLocation: Location;
  selectedDate: DateString;
  changeSelectedDate: (selectedDate: DateString) => any;
}

// tslint:disable-next-line:function-name
export default function DailyScheduleComponent({ selectedLocation, selectedDate, changeSelectedDate }: Props) {
  const { timezone, dateFormat } = selectedLocation.localeSettings;
  const onChangeSelectedDate = (value: Moment | string) => {
    isMoment(value) && changeSelectedDate(value.format(dateFormat) as DateString);
  };
  const isValidDate = (current: Moment) => moment.tz(timezone).isSameOrAfter(current);

  return (
    <div>
      <DatePicker
        value={selectedDate}
        onChange={onChangeSelectedDate}
        closeOnSelect={true}
        dateFormat={dateFormat}
        timeFormat={false}
        isValidDate={isValidDate}
        displayTimeZone={timezone}
        readonly={true}
      />
    </div>
  );
}
